<template>
    <div>
      <input 
        type="number" 
        v-model="dutyCycle" 
        class="form-control" 
        :min="0.01" 
        :max="100"
        @input="formatNumber"
      >
    </div>
  </template>
  
  <script>
  export default {
    name: 'FieldIntegrationDays',
    props: {
      value: Number
    },
    data() {
      return {
        dutyCycle: this.value
      };
    },
    watch: {
      value(newVal) {
        this.dutyCycle = newVal;
      },
      dutyCycle(newVal) {
        this.$emit('input', newVal);
      }
    },
    methods: {
      formatNumber() {
        this.dutyCycle = Number(this.dutyCycle).toLocaleString();
      }
    }
  }
  </script>
  